module.exports = __webpack_public_path__ + "00982c1c0981be75d81779b183c8fcf7.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/pos/closeTable.png
// module id = 492
// module chunks = 0